import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { SEOHead } from "@/components/SEOHead";
import { Reveal } from "@/components/Reveal";
import { PROYEK } from "@/data/company";

export default function Projects() {
  return (
    <>
      <SEOHead
        title="Portofolio Proyek | PT. Luminara Global Persada"
        description="Portofolio PT. Luminara Global Persada: cakupan proyek konstruksi gedung, infrastruktur, interior, arsitektur, dan lanskap di Jawa Barat dan sekitarnya."
      />

      <section className="pt-40 pb-20 bg-navy-900 border-b border-white/10" data-testid="projects-header">
        <div className="container-site">
          <Reveal>
            <p className="kicker mb-4">Portofolio</p>
            <h1 className="font-heading font-semibold text-4xl md:text-5xl tracking-tight max-w-3xl">
              Portofolio Proyek PT. Luminara Global Persada
            </h1>
            <p className="mt-6 max-w-2xl text-slate-400 leading-relaxed">
              Representasi cakupan pekerjaan yang kami layani di bidang konstruksi, arsitektur,
              interior, lanskap, dan pengadaan.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="section-pad" data-testid="projects-grid-section">
        <div className="container-site">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {PROYEK.map((p, i) => (
              <Reveal key={p.name} delay={(i % 3) * 0.08}>
                <article
                  data-testid={`project-card-${i}`}
                  className="group bg-navy-900 border border-white/10 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-gold/50 h-full flex flex-col"
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={p.image}
                      alt={`${p.name} — ${p.type} oleh PT. Luminara Global Persada di ${p.location}`}
                      className="w-full h-60 object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#060B19]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                      <p className="text-sm text-white leading-relaxed">{p.result}</p>
                    </div>
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <p className="flex items-center gap-2 text-xs tracking-widest uppercase text-gold">
                      <MapPin size={12} /> {p.location}
                    </p>
                    <h2 className="mt-2.5 font-heading font-semibold text-xl text-white">{p.name}</h2>
                    <p className="mt-2 text-sm text-slate-400">{p.type}</p>
                    <p className="mt-4 text-sm text-slate-400 leading-relaxed">{p.result}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <p className="mt-12 text-xs text-slate-500 leading-relaxed max-w-3xl" data-testid="projects-disclaimer">
              Catatan: daftar di atas merupakan representasi cakupan pekerjaan yang dilayani PT. Luminara
              Global Persada. Dokumentasi proyek aktual tersedia atas permintaan melalui kontak resmi perusahaan.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="section-pad bg-navy-900 border-t border-white/10" data-testid="projects-cta-section">
        <div className="container-site">
          <Reveal>
            <div className="border border-gold/30 bg-navy-800 px-8 py-14 md:p-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
              <div className="max-w-xl">
                <h2 className="font-heading font-semibold text-2xl md:text-3xl tracking-tight">
                  Proyek Anda bisa menjadi bagian berikutnya
                </h2>
                <p className="mt-4 text-slate-400 leading-relaxed">
                  Diskusikan rencana pembangunan, renovasi, atau pengadaan Anda bersama tim kami.
                </p>
              </div>
              <Link to="/kontak" data-testid="projects-cta-contact" className="btn-gold shrink-0">
                Mulai Diskusi <ArrowUpRight size={16} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
